import { v4 as uuid } from "uuid";

import { store } from "@/configureStore";

import { SearchActions } from "./actions";
import { createSelector } from "reselect";
export function createSearchModule(
  guid = uuid(),
  dataFetcher) {
  const searchActions = SearchActions({ guid, dataFetcher })
  return {
    guid,
    selector: createSelector(
      (state) => state.searchData?.[guid]?.inputValue,
      (state) => state.searchData?.[guid]?.results,
      (state) => state.searchData?.[guid]?.selectedItem,
      (state) => state.searchData?.[guid]?.isLoading,
      (inputValue, results, selectedItem, isLoading) => {
        return {
          inputValue,
          results: searchActions.search(inputValue, results),
          selectedItem,
          isLoading
        }
      }
    ),
    get state() {
      return store.ref.getState().searchData?.[guid];
    },
    defaultImage: ()=> {
      return store.ref.getState().searchData?.[guid]?.defaultImage;
    },

    actions: searchActions,
  };
}

